<template>
  <div>
    <select v-bind:value="value" @input="$emit('input', $event.target.value)">
      <option disabled value="">{{ label }}</option>
      <option v-for="device in devices" :key="device.deviceId" :value="device.deviceId">{{device.label}}</option>
    </select>
  </div>
</template>
<script>
export default {
  props: {
    devices: Array,
    value: String,
    label: String,
  },
};
</script>